import { Button, Carousel } from 'react-bootstrap';
import { useEffect, useState } from 'react';

function ControlledCarousel(props) {
    const album = props.photos;
    return (
        <Carousel style={{ width: "400px", margin:"auto"}}>


        {
          album.map((item,index) =>{
            return(
            <Carousel.Item>
            <img style={{ width: "400px", height: "500px", marginTop: "10px" }}
            className="d-block w-100 square border border-secondary border-3"
            src ={`/${item}`}
            alt={`Slide ${index}`}
            key={index}
            />
          </Carousel.Item>)
          })
        }
        
      </Carousel>
    )}

  export default ControlledCarousel;